function debounce(func, delay) {
    let timeoutId;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }
  
  class CartItem extends HTMLElement {
      constructor() {
        super();
        this.productQuanityField = this.querySelector("input.quantity__input");
        this.quantityWrapper = this.querySelector(".quantity");
        this.productPlusButton = this.querySelector("button.quantity__button.quantity-plus");
        this.productMinusButton = this.querySelector("button.quantity__button.quantity-minus");
        this.delayedIncreasedQuantity = debounce(this.incrementQuantity.bind(this), 500);
        this.delayedDecreaseQuantity = debounce(this.decrementQuantity.bind(this), 500);
        this.productPlusButton?.addEventListener("click",(e)=> this.delayedIncreasedQuantity(e));
        this.productMinusButton?.addEventListener("click",(e) =>  this.delayedDecreaseQuantity(e));
        this.productQuanityField?.addEventListener("change", this.validateQuantity.bind(this));
        this.querySelector('.cart-item-remove').addEventListener('click', this.removeCartItem.bind(this));
      }
      removeCartItem(e) {
        e.preventDefault();
        const key = this.getAttribute('data-key');
        this.style.opacity = 0.3
        const formData = {
          'id': key,
          "quantity": 0
        };
        this.changeCart(formData);
      }
      validateQuantity(e){
        e.preventDefault();
        const key = this.getAttribute('data-key');
        const formData = {
          'id': key,
          "quantity": Number(this.productQuanityField.value)
        };
        this.changeCart(formData);
      }
      
    
      incrementQuantity(e) {
        e.preventDefault();
        let current = Number(this.productQuanityField.value);
        let max= Number(this.productQuanityField.getAttribute('max'));
        let newval = (current + 1);
        if(max && newval > max) newval = max;
        this.productQuanityField.value = Number(newval);
        const key = this.getAttribute('data-key');
        const formData = {
          'id': key,
          "quantity": Number(newval)
        };
        this.changeCart(formData);
        e.preventDefault();
      }
      decrementQuantity(e) {
        let current = Number(this.productQuanityField.value);
        let newval = (current - 1); 
        this.productQuanityField.value = Number(newval);
        const key = this.getAttribute('data-key');
        const formData = {
          'id': key,
          "quantity": Number(newval)
        };
        this.changeCart(formData);
        e.preventDefault();
      }
      changeCart(formData){
        this.quantityWrapper.classList.add('loading');
        const domParser = new DOMParser(); 
        this.style.opacity = 0.3;
        const elementKey = this.getAttribute('data-key');
        this.style.pointerEvents = 'none';
        let cartItem = this;
        fetch(`${routes.cart_change_url}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(formData)
        }).then(function (data) {
          return data.json()
        })
        .then((data)=>{ 
              fetch(`/cart`)
              .then(res=>res.text())
              .then(html=>{
                  const cartHtml = domParser.parseFromString(html, 'text/html');
                  this.quantityWrapper.classList.remove('loading');
                  document.querySelector(`.cart-body`).innerHTML = cartHtml.querySelector(`.cart-body`).innerHTML;
                  document.querySelector(`.calculated-details`).innerHTML = cartHtml.querySelector(`.calculated-details`).innerHTML;
                  document.querySelector(`p.item-count`).innerHTML = cartHtml.querySelector(`p.item-count`).innerHTML;
                  document.querySelector('.mini-cart-bubble').textContent = cartHtml.querySelector(`p.item-count`).getAttribute('data-count');
                  if(data.status === 422) { 
                      const errorElement = document.createElement('div');
                      errorElement.classList.add('error-message');
                      errorElement.innerHTML = data.message;
                      document.querySelector(`[data-key="${elementKey}"] .quantity`).appendChild(errorElement);
                      return;
                    }
              })
         })
        .catch(function (error) {
          this.quantityWrapper.classList.remove('loading');
          console.error('Request failed', error)
        });
      }
    }
  customElements.define('cart-item', CartItem);
  
 
  
  
  